import React from "react";
import ReactDOM from "react-dom/client";

import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/charts/styles.css";

import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

import "./index.css";
import App from "./App";

// No plans of service worker for now
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// import reportWebVitals from "./reportWebVitals";
import { MantineProvider } from "@mantine/core";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { Notifications } from "@mantine/notifications";

import history from "./history";
import { theme } from "./styles";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <Notifications />
      <HistoryRouter history={history}>
        <App />
      </HistoryRouter>
    </MantineProvider>
  </React.StrictMode>,
);

// No need of service worker for now

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
